export const PageHeader = ({ title, subtitle, action, testid }) => (
  <header className="flex items-start justify-between gap-4 flex-wrap mb-6" data-testid={testid}>
    <div>
      <p className="text-[11px] tracking-[0.3em] uppercase text-amber-500 font-bold">Agency</p>
      <h1 className="font-serif text-3xl text-slate-800 mt-1">{title}</h1>
      {subtitle && <p className="text-sm text-slate-500 mt-1 max-w-2xl">{subtitle}</p>}
    </div>
    {action}
  </header>
);

export const Panel = ({ children, className = "" }) => (
  <section className={`bg-white border border-slate-200 rounded-xl ${className}`}>{children}</section>
);

export const Btn = ({ variant = "primary", children, className = "", ...props }) => {
  const cls = {
    primary: "bg-slate-800 hover:bg-slate-900 text-white",
    ghost: "bg-white border border-slate-300 hover:border-slate-500 text-slate-700",
    danger: "bg-rose-600 hover:bg-rose-700 text-white",
  }[variant];
  return (
    <button {...props} className={`inline-flex items-center gap-2 px-4 py-2 rounded-lg text-[12px] font-bold tracking-[0.14em] uppercase transition-colors ${cls} ${className}`}>
      {children}
    </button>
  );
};

export const Pill = ({ children, tone = "slate" }) => {
  const map = {
    slate: "bg-slate-100 text-slate-700 border-slate-200",
    sky: "bg-sky-50 text-sky-700 border-sky-200",
    amber: "bg-amber-50 text-amber-700 border-amber-200",
    rose: "bg-rose-50 text-rose-700 border-rose-200",
    emerald: "bg-emerald-50 text-emerald-700 border-emerald-200",
    violet: "bg-violet-50 text-violet-700 border-violet-200",
  };
  return <span className={`inline-flex items-center text-[10.5px] font-bold tracking-[0.14em] uppercase px-2 py-1 border rounded ${map[tone] || map.slate}`}>{children}</span>;
};

export const Input = ({ label, hint, testid, ...props }) => (
  <label className="block">
    {label && <span className="block text-[11px] font-bold tracking-[0.14em] uppercase text-slate-500 mb-1.5">{label}</span>}
    <input {...props} data-testid={testid} className="w-full bg-white border border-slate-300 rounded-lg px-3 py-2 text-sm focus:border-slate-700 focus:outline-none" />
    {hint && <p className="text-[11px] text-slate-500 mt-1">{hint}</p>}
  </label>
);

export const Select = ({ label, children, testid, ...props }) => (
  <label className="block">
    {label && <span className="block text-[11px] font-bold tracking-[0.14em] uppercase text-slate-500 mb-1.5">{label}</span>}
    <select {...props} data-testid={testid} className="w-full bg-white border border-slate-300 rounded-lg px-3 py-2 text-sm focus:border-slate-700 focus:outline-none">
      {children}
    </select>
  </label>
);

export const TextArea = ({ label, hint, testid, ...props }) => (
  <label className="block">
    {label && <span className="block text-[11px] font-bold tracking-[0.14em] uppercase text-slate-500 mb-1.5">{label}</span>}
    <textarea {...props} data-testid={testid} className="w-full bg-white border border-slate-300 rounded-lg px-3 py-2 text-sm focus:border-slate-700 focus:outline-none" />
    {hint && <p className="text-[11px] text-slate-500 mt-1">{hint}</p>}
  </label>
);

export const Empty = ({ title = "Nothing here yet", hint, testid }) => (
  <div data-testid={testid} className="bg-white border border-slate-200 border-dashed rounded-xl px-6 py-10 text-center">
    <p className="text-sm font-semibold text-slate-700">{title}</p>
    {hint && <p className="text-[12px] text-slate-500 mt-1">{hint}</p>}
  </div>
);
